import React, {  useEffect, useLayoutEffect, useState } from 'react'
import Asterix from '../../icons/asterix'
import EventCard from './event-card'
import Decoration from './decoration'
import Arrow from '../../icons/arrow'
import FormatPixel from '../utils/formatPixel'

import WinningsCard from './winnings-card'
import usePopupUrl from '../../hooks/use-popup-url'



function Winnings({ winnings }) {
    const [currentPopUp, setCurrentPopup] = usePopupUrl()


    return winnings.map((winning, index) => {
        const model = winning.model.apiKey

        if (model === 'winning') {

            return (
                <WinningsCard key={winning.name} open={(currentPopUp === winning.link)} setOpen={setCurrentPopup} winning={winning} />
            )
        }
        return (
            <Decoration key={winning.name} className='h-full' event={winning} />
        )

    })
}




export default function Events({ events, shopLinksEnabled,shopOnlineHeading }) {
 
  



    const [mobile,setMobile] = useState(false)

    const [filter, setFilter] = useState('shopping')

    useLayoutEffect(() =>{
        if(window.location.search !== ''){
            return  
        }
        if(window.innerWidth < 768 ){
            return filterBy('',false)
        }
        return filterBy('shopping',false)
    },[])



    function filterBy (name,scrollTo = true) {
       if( window.innerWidth < 768 && scrollTo){
            document.querySelector('#events').scrollIntoView()
       }
        setFilter(name)
    }

    function FilterButton({ name, filtering = name }) {

        return (
            <button onClick={() => filterBy(filtering,true)} className='flex'>
                <h3 className="max-w-230 "><FormatPixel text={name} /></h3> <Arrow className={'mt-[4px]  ml-[25px] arrow  md:mt-[0px] ' + (filter === filtering ? 'open' : '')} />
            </button>
        )
    }

    useEffect(() => {

        const params = new URLSearchParams(document.location.search);
        const offer = params.get('offer')
        if (offer) {

             document.querySelector('#events').scrollIntoView()
          
            setFilter(offer)
        }
    }, [])






    return (
        <div id='events' className='mb-[150px]'>

            <div className="grid grid-cols-3 mb-[50px] md:grid-cols-1 md:gap-y-[20px] md:mb-[20px]">
                <FilterButton name='shopping' />
                <div className={' items-center mb-[15px] md:mb-[0px] hidden md:flex ' + (((filter === 'shopping') && shopOnlineHeading) ? '' : 'md:hidden')}>
                    <Asterix />
                    <h5 className='ml-[20px] md:ml-[10px]'>Shop Online</h5>
                </div>
                <div className={"  grid-cols-1 gap-x-[20px] gap-y-[20px] tab hidden md:grid md:gap-x-[10px]  md:gap-y-0  md:mb-[25px]   " + (filter === 'shopping' ? 'open' : '')}>

                    {[
                        events.shopping.slice(0, Math.round(events.shopping.length / 2)),
                        events.shopping.slice(Math.round(events.shopping.length / 2), Math.round(events.shopping.length / 2) * 3),

                    ].map((col, index) => {

                        return (
                            <div key={index}>
                                {col.map((event) => {
                                    const model = event.model.apiKey

                                    if (model === 'event') {
                                        return (
                                            <EventCard shopLinksEnabled={shopLinksEnabled} id={event.id} key={event.id} event={event} />
                                        )
                                    }
                                    return (
                                        <Decoration id={event.id} key={event.id} event={event} />
                                    )
                                })}
                            </div>
                        )

                    })}
                </div>
                <FilterButton name='party' />
                <div className={" grid-cols-1 gap-x-[20px] gap-y-[20px] tab hidden md:grid md:gap-x-[10px] md:gap-y-0  md:mb-[25px] " + (filter === 'party' ? 'open' : '')}>

                    {[
                        events.party.slice(0, Math.round(events.party.length / 2)),
                        events.party.slice(Math.round(events.party.length / 2), Math.round(events.party.length / 2) * 3),

                    ].map((col, index) => {

                        return (
                            <div key={index}>
                                {col.map((event) => {
                                    const model = event.model.apiKey

                                    if (model === 'event') {
                                        return (
                                            <EventCard online={true} shopLinksEnabled={shopLinksEnabled} id={event.id} key={event.id} event={event} />
                                        )
                                    }
                                    return (
                                        <Decoration id={event.id} key={event.id} event={event} />
                                    )
                                })}
                            </div>
                        )

                    })}
                </div>
                <FilterButton name='party bags & winnings' filtering='winnings' />
            </div>

            <div className={'flex items-center mb-[15px] md:hidden ' + ((filter !== 'shopping' || !shopOnlineHeading) ? 'opacity-0' : '')}>
                <Asterix />
                <h5 className='ml-[20px] md:ml-[10px]'>Shop Online</h5>
            </div>

            <div>
                <div className={"grid  grid-cols-3 gap-x-[20px] gap-y-[20px] tab  md:hidden  " + (filter === 'shopping' ? 'open' : '')}>

                    {[
                        events.shopping.slice(0, Math.round(events.shopping.length / 3)),
                        events.shopping.slice(Math.round(events.shopping.length / 3), Math.round(events.shopping.length / 3) * 2),
                        events.shopping.slice(Math.round(events.shopping.length / 3) * 2, Math.round(events.shopping.length / 3) * 4)
                    ].map((col, index) => {


                        return (
                            <div key={index}>
                                {col.map((event, index) => {
                                    const model = event.model.apiKey
                                    if (model === 'event') {
                                        return (
                                            <EventCard shopLinksEnabled={shopLinksEnabled} id={event.id} key={event.id} event={event} />
                                        )
                                    }
                                    return (
                                        <Decoration id={event.id} key={event.id} event={event} />
                                    )
                                })}
                            </div>
                        )

                    })}
                </div>



                <div className={"grid  grid-cols-3 gap-x-[20px] gap-y-[20px] tab  md:hidden " + (filter === 'party' ? 'open' : '')}>

                    {[
                        events.party.slice(0, Math.round(events.party.length / 3)),
                        events.party.slice(Math.round(events.party.length / 3), Math.round(events.party.length / 3) * 2),
                        events.party.slice(Math.round(events.party.length / 3) * 2, Math.round(events.party.length / 3) * 4)
                    ].map((col, index) => {

                        return (
                            <div key={index}>
                                {col.map((event) => {
                                    const model = event.model.apiKey

                                    if (model === 'event') {
                                        return (
                                            <EventCard online={true} shopLinksEnabled={shopLinksEnabled} id={event.id} key={event.id} event={event} />
                                        )
                                    }
                                    return (
                                        <Decoration id={event.id} key={event.id} event={event} />
                                    )
                                })}
                            </div>
                        )

                    })}
                </div>


                <div className={"grid  grid-cols-3 gap-x-[20px] gap-y-[20px] tab md:grid-cols-1  md:gap-x-[10px] md:gap-y-[15px]    " + (filter === 'winnings' ? 'open' : '')}>
                    <Winnings winnings={events.winnings} />

                </div>

            </div>

        </div>
    )
}
